// import { useNavigate } from "react-router-dom";
// import GetAQuoteButton from "../GetAQuoteButton";
// import classes from "./ProductCard.module.css";

// export default function ProductCard({ product }) {
//   const navigate = useNavigate();

//   const handleViewProduct = () => {
//     const slug = product.product_slug || product.sku;
//     navigate(`/product/${slug}`);
//   };

//   const displayName =
//     product.productName.length > 40
//       ? product.productName.slice(0, 40) + "..."
//       : product.productName;

//   return (
//     <div
//       className={classes.productCard}
//       onClick={handleViewProduct}
//       role="button"
//     >
//       <div className={classes.productImage}>
//         <img src={product.productImage} alt={product.productName} />
//       </div>
//       <div className={classes.productContent}>
//         <h3 title={product.productName}>{displayName}</h3>
//         <p className={classes.productSku}>SKU: {product.sku}</p>
//         {/* <p className={classes.productPrice}>
//           {product.salePrice && parseFloat(product.salePrice) > 0 ? (
//             <>
//               <span style={{ textDecoration: "line-through", color: "#999", marginRight: "0.5rem" }}>
//                 £{Number(product.regularPrice || 0).toLocaleString("en-UK", {
//                   minimumFractionDigits: 2,
//                 })}
//               </span>
//               £{Number(product.salePrice).toLocaleString("en-UK", {
//                 minimumFractionDigits: 2,
//               })}
//             </>
//           ) : (
//             `£${Number(product.regularPrice || 0).toLocaleString("en-UK", {
//               minimumFractionDigits: 2,
//             })}`
//           )}
//         </p> */}
//         {/* Prevent propagation so button click won't trigger card click */}
//         <div onClick={(e) => e.stopPropagation()}>
//           <GetAQuoteButton sku={product.sku} />
//         </div>
//       </div>
//     </div>
//   );
// }

import { useNavigate } from "react-router-dom";
import GetAQuoteButton from "../GetAQuoteButton";
import classes from "./ProductCard.module.css";
import { PLACEHOLDER_IMAGE } from "../../utils/image";

export default function ProductCard({ product }) {
  const navigate = useNavigate();

  const handleViewProduct = () => {
    const slug = product.product_slug || product.sku;
    navigate(`/product/${slug}`);
  };

  const displayName =
    product.productName.length > 40
      ? product.productName.slice(0, 40) + "..."
      : product.productName;

  return (
    <div
      className={classes.productCard}
      onClick={handleViewProduct}
      role="button"
    >
      <div className={classes.productCardInnerWrapper}>
        <div className={classes.productImage}>
          {/* ⭐ CATEGORY BADGE ⭐ */}
          {product.categoryName && (
            <span className={classes.badge}>{product.categoryName}</span>
          )}

          <img
            src={product.productImage}
            alt={product.productName}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = PLACEHOLDER_IMAGE;
            }}
          />
        </div>
        <div className={classes.productContent}>
          <h3 title={product.productName}>{displayName}</h3>
          <p className={classes.productSku}>SKU: {product.sku}</p>
        </div>

        <div onClick={(e) => e.stopPropagation()}>
          <GetAQuoteButton sku={product.sku} />
        </div>
      </div>
    </div>
  );
}
